module.exports = __webpack_public_path__ + "img/california.676b0a8f.png";